import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Head from 'next/head';
import { Trans, useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import Section from '../components/Section';

const Privacy = () => {
  const { t } = useTranslation('privacy');

  return (
    <Section header={t('Datenschutzbestimmungen')}>
      <Grid
        item
        xs={12}
        sm={8}
        sx={{
          wordWrap: 'break-word',
        }}
      >
        {/* <p>*/}
        {/*  Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der*/}
        {/*  EU-Datenschutzgrundverordnung (DSGVO), ist:*/}
        {/* </p>*/}
        {/* <p>*/}
        {/*  ???*/}
        {/*  <br />*/}
        {/*  ???*/}
        {/*  <br />*/}
        {/*  ???*/}
        {/* </p>*/}
        <h2>{t('Ihre Betroffenenrechte')}</h2>
        <p>
          {t(
            'Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit folgende Rechte ausüben:'
          )}
        </p>
        <ul>
          <li>
            {t(
              'Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),'
            )}
          </li>
          <li>
            {t(
              'Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),'
            )}
          </li>
          <li>
            {t('Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),')}
          </li>
          <li>
            {t(
              'Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO),'
            )}
          </li>
          <li>
            {t(
              'Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO) und'
            )}
          </li>
          <li>
            {t(
              'Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO).'
            )}
          </li>
        </ul>
        <p>
          {t(
            'Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen.'
          )}
        </p>
        <p>
          {t(
            'Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden'
          )}
        </p>
        <h2>
          {t('Erfassung allgemeiner Informationen beim Besuch unserer Website')}
        </h2>
        <h3>{t('Art und Zweck der Verarbeitung:')}</h3>
        <p>{t('Wenn Sie auf unsere Website zugreifen')}</p>
        <p>{t('Sie werden insbesondere zu folgenden Zwecken verarbeitet:')}</p>
        <ul>
          <li>
            {t(
              'Sicherstellung eines problemlosen Verbindungsaufbaus der Website,'
            )}
          </li>
          <li>
            {t('Sicherstellung einer reibungslosen Nutzung unserer Website,')}
          </li>
          <li>{t('Auswertung der Systemsicherheit und -stabilität sowie')}</li>
          <li>{t('zur Optimierung unserer Website.')}</li>
        </ul>
        <p>{t('Wir verwenden Ihre Daten nicht')}</p>
        <h3>{t('Rechtsgrundlage und berechtigtes Interesse:')}</h3>
        <p>{t('Die Verarbeitung erfolgt gemäß Art')}</p>
        <h3>{t('Empfänger:')}</h3>
        <p>{t('Empfänger der Daten sind ggf. technische Dienstleister')}</p>
        <p></p>
        <h3>{t('Speicherdauer:')}</h3>
        <p>
          {t(
            'Die Daten werden gelöscht, sobald diese für den Zweck der Erhebung nicht mehr erforderlich sind.'
          )}
        </p>
        <p>
          {t(
            'Im Falle der Speicherung der Daten in Logfiles ist dies nach spätestens 14 Tagen der Fall.'
          )}
        </p>
        <p></p>
        <h3>{t('Bereitstellung vorgeschrieben oder erforderlich:')}</h3>
        <p>
          {t(
            'Die Bereitstellung der vorgenannten personenbezogenen Daten ist weder gesetzlich noch vertraglich vorgeschrieben.'
          )}
        </p>
        <p></p>
        <h2>{t('Cookies')}</h2>
        <p>
          {t(
            'Wie viele andere Webseiten verwenden wir auch so genannte „Cookies“.'
          )}
        </p>
        <p>
          {t(
            'Sie können einzelne Cookies oder den gesamten Cookie-Bestand löschen.'
          )}
        </p>
        <ul>
          <li>
            Mozilla Firefox:{' '}
            <a
              href="https://support.mozilla.org/de/kb/cookies-loeschen-daten-von-websites-entfernen"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              https://support.mozilla.org/de/kb/cookies-loeschen-daten-von-websites-entfernen
            </a>
          </li>
          <li>
            Internet Explorer:{' '}
            <a
              href="https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies
            </a>
          </li>
          <li>
            Google Chrome:{' '}
            <a
              href="https://support.google.com/accounts/answer/61416?hl=de"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              https://support.google.com/accounts/answer/61416?hl=de
            </a>
          </li>
          <li>
            Opera:{' '}
            <a
              href="http://www.opera.com/de/help"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              http://www.opera.com/de/help
            </a>
          </li>
          <li>
            Safari:{' '}
            <a
              href="https://support.apple.com/kb/PH17191?locale=de_DE&viewlocale=de_DE"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              https://support.apple.com/kb/PH17191?locale=de_DE&viewlocale=de_DE
            </a>
          </li>
        </ul>
        <h3>{t('Speicherdauer und eingesetzte Cookies:')}</h3>
        <p>{t('Soweit Sie uns durch Ihre Browsereinstellungen')}</p>
        <p></p>
        <h2>{t('Technisch notwendige Cookies')}</h2>
        <h3>{t('Art und Zweck der Verarbeitung:')}</h3>
        <p>
          {t(
            'Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten.'
          )}
        </p>
        <p>
          {t(
            'Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für die Nutzer zu vereinfachen.'
          )}
        </p>
        <p>{t('Für folgende Anwendungen benötigen wir Cookies:')}</p>
        <p></p>
        <h3>{t('Rechtsgrundlage und berechtigtes Interesse:')}</h3>
        <p>{t('Die Verarbeitung erfolgt gemäß Art #2')}</p>
        <h3>{t('Empfänger:')}</h3>
        <p>{t('Empfänger der Daten sind ggf. technische Dienstleister')}</p>
        <p></p>
        <h3>{t('Bereitstellung vorgeschrieben oder erforderlich:')}</h3>
        <p>
          {t(
            'Die Bereitstellung der vorgenannten personenbezogenen Daten ist weder gesetzlich noch vertraglich vorgeschrieben. #2'
          )}
        </p>
        <h3>{t('Widerspruch')}</h3>
        <p>
          {t(
            'Lesen Sie dazu die Informationen über Ihr Widerspruchsrecht nach Art. 21 DSGVO weiter unten.'
          )}
        </p>
        <p></p>
        <h2>{t('Registrierung auf unserer Website')}</h2>
        <h3>{t('Art und Zweck der Verarbeitung:')}</h3>
        <p>
          {t(
            'Für die Registrierung auf unserer Website benötigen wir einige personenbezogene Daten, die über eine Eingabemaske an uns übermittelt werden.'
          )}
        </p>
        <p>
          {t(
            'Zum Zeitpunkt der Registrierung werden zusätzlich folgende Daten erhoben:'
          )}
        </p>
        <p></p>
        <p>
          {t(
            'Ihre Registrierung ist für das Bereithalten bestimmter Inhalte und Leistungen auf unserer Website erforderlich.'
          )}
        </p>
        <h3>{t('Rechtsgrundlage:')}</h3>
        <p>
          {t(
            'Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage einer Einwilligung des Nutzers (Art. 6 Abs. 1 lit. a DSGVO).'
          )}
        </p>
        <h3>{t('Empfänger:')}</h3>
        <p>{t('Empfänger der Daten sind ggf. technische Dienstleister')}</p>
        <p></p>
        <h3>{t('Speicherdauer:')}</h3>
        <p>
          {t(
            'Daten werden in diesem Zusammenhang nur verarbeitet, solange die entsprechende Einwilligung vorliegt.'
          )}
        </p>
        <h3>{t('Bereitstellung vorgeschrieben oder erforderlich:')}</h3>
        <p>
          {t(
            'Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig, allein auf Basis Ihrer Einwilligung.'
          )}
        </p>
        <p></p>
        <h2>{t('Erbringung kostenpflichtiger Leistungen')}</h2>
        <h3>{t('Art und Zweck der Verarbeitung:')}</h3>
        <p>
          {t(
            'Zur Erbringung kostenpflichtiger Leistungen werden von uns zusätzliche Daten erfragt'
          )}
        </p>
        <h3>{t('Rechtsgrundlage:')}</h3>
        <p>
          {t(
            'Die Verarbeitung der Daten, die für den Abschluss des Vertrages erforderlich ist, basiert auf Art. 6 Abs. 1 lit. b DSGVO.'
          )}
        </p>
        <h3>{t('Empfänger:')}</h3>
        <p>{t('Empfänger der Daten sind ggf. Auftragsverarbeiter.')}</p>
        <p></p>
        <h3>{t('Speicherdauer:')}</h3>
        <p>
          {t(
            'Wir speichern diese Daten in unseren Systemen bis die gesetzlichen Aufbewahrungsfristen abgelaufen sind.'
          )}
        </p>
        <h3>{t('Bereitstellung vorgeschrieben oder erforderlich:')}</h3>
        <p>
          {t(
            'Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig. #2'
          )}
        </p>
        <p></p>
        <h2>{t('Newsletter')}</h2>
        <h3>{t('Art und Zweck der Verarbeitung:')}</h3>
        <p>
          {t(
            'Für die Zustellung unseres Newsletters erheben wir personenbezogene Daten, die über eine Eingabemaske an uns übermittelt werden.'
          )}
        </p>
        <p>
          {t(
            'Für eine wirksame Registrierung benötigen wir eine valide E-Mail-Adresse.'
          )}
        </p>
        <h3>{t('Rechtsgrundlage:')}</h3>
        <p>{t('Auf Grundlage Ihrer ausdrücklich erteilten Einwilligung')}</p>
        <p>
          {t(
            'Die Einwilligung zur Speicherung Ihrer persönlichen Daten und ihrer Nutzung für den Newsletterversand können Sie jederzeit mit Wirkung für die Zukunft widerrufen.'
          )}
        </p>
        <h3>{t('Empfänger:')}</h3>
        <p>{t('Empfänger der Daten sind ggf. Auftragsverarbeiter.')}</p>
        <p></p>
        <h3>{t('Speicherdauer:')}</h3>
        <p>
          {t(
            'Die Daten werden in diesem Zusammenhang nur verarbeitet, solange die entsprechende Einwilligung vorliegt. Danach werden sie gelöscht.'
          )}
        </p>
        <h3>{t('Bereitstellung vorgeschrieben oder erforderlich:')}</h3>
        <p>
          {t(
            'Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig, allein auf Basis Ihrer Einwilligung. Ohne bestehende Einwilligung können wir Ihnen unseren Newsletter leider nicht zusenden.'
          )}
        </p>
        <h3>{t('Widerruf der Einwilligung:')}</h3>
        <p>
          {t(
            'Die Einwilligung zur Speicherung Ihrer persönlichen Daten und ihrer Nutzung für den Newsletterversand können Sie jederzeit mit Wirkung für die Zukunft widerrufen. #2'
          )}
        </p>
        <p></p>
        <h2>{t('Kontaktformular')}</h2>
        <h3>{t('Art und Zweck der Verarbeitung:')}</h3>
        <p>
          {t(
            'Die von Ihnen eingegebenen Daten werden zum Zweck der individuellen Kommunikation mit Ihnen gespeichert.'
          )}
        </p>
        <h3>{t('Rechtsgrundlage:')}</h3>
        <p>
          {t(
            'Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt auf der Grundlage eines berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO).'
          )}
        </p>
        <p>
          {t(
            'Durch Bereitstellung des Kontaktformulars möchten wir Ihnen eine unkomplizierte Kontaktaufnahme ermöglichen.'
          )}
        </p>
        <p>
          {t(
            'Sofern Sie mit uns Kontakt aufnehmen, um ein Angebot zu erfragen, erfolgt die Verarbeitung der in das Kontaktformular eingegebenen Daten zur Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO).'
          )}
        </p>
        <h3>{t('Empfänger:')}</h3>
        <p>{t('Empfänger der Daten sind ggf. Auftragsverarbeiter.')}</p>
        <p></p>
        <h3>{t('Speicherdauer:')}</h3>
        <p>
          {t(
            'Daten werden spätestens 6 Monate nach Bearbeitung der Anfrage gelöscht.'
          )}
        </p>
        <p>
          {t(
            'Sofern es zu einem Vertragsverhältnis kommt, unterliegen wir den gesetzlichen Aufbewahrungsfristen nach HGB und löschen Ihre Daten nach Ablauf dieser Fristen.'
          )}
        </p>
        <h3>{t('Bereitstellung vorgeschrieben oder erforderlich:')}</h3>
        <p>
          {t(
            'Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig. Wir können Ihre Anfrage jedoch nur bearbeiten, sofern Sie uns Ihren Namen, Ihre E-Mail-Adresse und den Grund der Anfrage mitteilen.'
          )}
        </p>
        <p></p>
        <h2>{t('Verwendung von Google Analytics')}</h2>
        <p>
          {t(
            'Soweit Sie ihre Einwilligung gegeben haben, wird auf dieser Website Google Analytics eingesetzt'
          )}
        </p>
        <p>
          {t(
            'Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter'
          )}
          <a
            href="https://www.google.com/analytics/terms/de.html und unter https://policies.google.com/?hl=de"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://www.google.com/analytics/terms/de.html und unter
            https://policies.google.com/?hl=de
          </a>
          .
        </p>
        <p>
          {t(
            'Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen'
          )}
        </p>
        <p>{t('Die von uns gesendeten und mit Cookies, Nutzerkennungen')}</p>
        <h3>{t('Widerruf der Einwilligung:')}</h3>

        <p>
          <Trans
            i18nKey="Sie können das Tracking durch Google Analytics auf unserer Website unterbinden"
            ns="privacy"
          >
            Sie können das Tracking durch Google Analytics auf unserer Website
            unterbinden, indem Sie
            <a
              title="Google Analytics Opt-Out-Cookie setzen"
              onClick="gaOptout();alert('Google Analytics wurde deaktiviert');"
              href="#"
            >
              diesen Link anklicken
            </a>
            . Dabei wird ein Opt-out-Cookie auf Ihrem Gerät installiert. Damit
            wird die Erfassung durch Google Analytics für diese Website und für
            diesen Browser zukünftig verhindert, solange das Cookie in Ihrem
            Browser installiert bleibt.
          </Trans>
        </p>

        <p>
          {t(
            'Sie können darüber hinaus die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern'
          )}
        </p>
        <p>
          <Trans
            i18nKey="Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten"
            ns="privacy"
          >
            Sie können darüber hinaus die Erfassung der durch das Cookie
            erzeugten und auf Ihre Nutzung der Webseite bezogenen Daten (inkl.
            Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten
            durch Google verhindern, indem sie das unter dem folgenden Link
            verfügbare Browser-Plugin herunterladen und installieren:
            <a
              href="http://tools.google.com/dlpage/gaoptout?hl=de"
              rel="noopener noreferrer"
              target="_blank"
            >
              Browser Add On zur Deaktivierung von Google Analytics
            </a>
            .
          </Trans>
        </p>
        <p></p>
        <h2>{t('Verwendung von Scriptbibliotheken (Google Webfonts)')}</h2>
        <p>
          {t(
            'Um unsere Inhalte browserübergreifend korrekt und grafisch ansprechend darzustellen'
          )}
        </p>
        <p>
          <Trans
            i18nKey="Weitere Informationen zu Google Web Fonts finden Sie unter"
            ns="privacy"
          >
            Weitere Informationen zu Google Web Fonts finden Sie unter
            <a
              href="https://developers.google.com/fonts/faq"
              rel="noopener nofollow noreferrer"
              target="_blank"
            >
              https://developers.google.com/fonts/faq
            </a>
            und in der Datenschutzerklärung von Google:
            <a
              href="https://www.google.com/policies/privacy/"
              rel="noopener nofollow noreferrer"
              target="_blank"
            >
              https://www.google.com/policies/privacy/
            </a>
            .
          </Trans>
        </p>
        <p></p>
        <h2>Google AdWords</h2>
        <p>{t('Unsere Website nutzt das Google Conversion-Tracking.')}</p>
        <p>
          {t(
            'Besucht der Nutzer bestimmte Seiten unserer Website und das Cookie ist noch nicht abgelaufen'
          )}
        </p>
        <p>
          <Trans
            i18nKey="Nähere Informationen über die Datenverarbeitung durch Google können Sie den Google-Datenschutzhinweisen entnehmen"
            ns="privacy"
          >
            Nähere Informationen über die Datenverarbeitung durch Google können
            Sie den Google-Datenschutzhinweisen entnehmen:
            <a
              href="https://policies.google.com/privacy"
              rel="noopener nofollow noreferrer"
              target="_blank"
            >
              https://policies.google.com/privacy
            </a>
            . Dort können Sie im Datenschutzcenter auch Ihre persönlichen
            Datenschutz-Einstellungen verändern.
          </Trans>
        </p>
        <h3>{t('Widerruf der Einwilligung:')}</h3>
        <p>
          {t(
            'Vom Anbieter wird derzeit keine Möglichkeit für einen einfachen Opt-out oder ein Blockieren der Datenübertragung angeboten.'
          )}
        </p>
        <p></p>
        <h2>{t('Einsatz von Google Remarketing')}</h2>
        <p>
          {t(
            'Diese Website verwendet die Remarketing-Funktion der Google Inc.'
          )}
        </p>
        <p>
          {t(
            'Die Funktion dient dazu, Websitebesuchern innerhalb des Google-Werbenetzwerks interessenbezogene Werbeanzeigen zu präsentieren.'
          )}
        </p>
        <p>
          <Trans
            i18nKey="Nähere Informationen über die Datenverarbeitung durch Google können Sie den Google-Datenschutzhinweisen entnehmen"
            ns="privacy"
          >
            Nähere Informationen über die Datenverarbeitung durch Google können
            Sie den Google-Datenschutzhinweisen entnehmen:{' '}
            <a
              href="https://policies.google.com/privacy"
              rel="noopener nofollow noreferrer"
              target="_blank"
            >
              https://policies.google.com/privacy
            </a>
            . Dort können Sie im Datenschutzcenter auch Ihre persönlichen
            Datenschutz-Einstellungen verändern.
          </Trans>
        </p>
        <h3>{t('Widerruf der Einwilligung:')}</h3>
        <p>
          {t(
            'Vom Anbieter wird derzeit keine Möglichkeit für einen einfachen Opt-out oder ein Blockieren der Datenübertragung angeboten.'
          )}
        </p>
        <p></p>
        <h2>{t('SSL-Verschlüsselung')}</h2>
        <p>
          {t(
            'Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.'
          )}
        </p>
        <Box sx={{ py: 5 }}>
          <h1>
            {t('Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO')}
          </h1>
          <h3>{t('Einzelfallbezogenes Widerspruchsrecht')}</h3>
          <p>
            {t(
              'Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben'
            )}
          </p>
          <p>
            {t(
              'Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten'
            )}
          </p>
          <h3>{t('Empfänger eines Widerspruchs')}</h3>
          <p>
            <Typography variant="body2">Chain.Report FZCO</Typography>
            <Typography variant="body2">
              Dubai Silicon Oasis, DDP, Building A2
            </Typography>
            <Typography variant="body2">United Arab Emirates</Typography>
          </p>
        </Box>

        <Box sx={{ py: 5 }}>
          <h1>{t('Änderung unserer Datenschutzbestimmungen')}</h1>
          <p>
            {t(
              'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht'
            )}
          </p>
          <h2>{t('Fragen an den Datenschutzbeauftragten')}</h2>
          <p>
            {t(
              'Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation:'
            )}
          </p>
        </Box>
      </Grid>
    </Section>
  );
};

export default Privacy;

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['privacy', 'common'])),
    },
  };
}
